import React, { useEffect } from 'react';
import { MenuItem, Select, Grid, Typography } from '@material-ui/core';
import { useQuery, useLazyQuery } from '@apollo/react-hooks';
import CertificationForm from './CertificationForm';
import useStyles from './Style';
import {
  SERVICE_QUERY_AGGREGATOR,
  SERVICE_QUERY_PROVIDER,
  SERVICE_QUERY,
  WORKFLOW_LIST,
  GET_SIMULATION_DATA
} from '../graphQL/queries';
interface ServiceCertificationProps {
  participant: any;
  workflowCode: string;
  testNames?: any;
}

type workflowInfo = {
  workflowCode: string;
  workflowName: string;
  operations?: any;
};

type workflowObj = {
  workflow: workflowContentData;
};

type workflowContentData = {
  content: workflowInfo[];
};

const ServiceCertification: any = (props: ServiceCertificationProps) => {
  let customerCode = 'BYManagedTestCustomer';
  let provider = 'BYManagedTestProvider';
  let initiator = '';
  if (props?.participant.participantType === 'CUSTOMER') {
    customerCode = props?.participant?.participantCode;
    initiator = 'PROVIDER';
  } else if (props?.participant.participantType === 'PROVIDER') {
    provider = props?.participant?.participantCode;
    initiator = 'CUSTOMER';
  } else if (props?.participant.participantType === 'AGGREGATOR') {
    initiator = 'CUSTOMER';
  } else if (props?.participant.participantType === 'CUSTOMER_AGGREGATOR') {
    initiator = 'PROVIDER';
  }

  const classes = useStyles();
  const initialState = {
    simulationCode: '',
    eventType: '',
    partner: '',
    simulationName: '',
    providerCode: provider
  };
  const [{ simulationCode, eventType, partner, simulationName, providerCode }, setFormField] = React.useState({
    ...initialState
  });
  const [partners, setPartners] = React.useState<any>([]);
  const [operations, setOperations] = React.useState<any>([]);

  const { workflowCode, participant } = props;

  const workflowList = useQuery<workflowObj, {}>(WORKFLOW_LIST, {});
  const { data: aggregators } = useQuery(SERVICE_QUERY_AGGREGATOR, {
    variables: {
      workflowCode: workflowCode,
      participantType: 'AGGREGATOR'
    }
  });
  const { data: providers } = useQuery(SERVICE_QUERY_PROVIDER, {
    variables: {
      workflowCode: workflowCode
    }
  });
  const { data: customers } = useQuery(SERVICE_QUERY, {
    variables: {
      workflowCode: workflowCode
    }
  });

  const [getSimulatedData, { data: testNames }] = useLazyQuery(GET_SIMULATION_DATA, {});

  useEffect(() => {
    const workflow = workflowList?.data?.workflow?.content?.filter((item: any) => item.workflowCode === workflowCode);
    getSimulatedData({
      variables: {
        search: `serviceNm=${workflow?.[0]?.workflowName}`
      }
    });
  }, []);

  useEffect(() => {
    if (workflowCode === 'freightTracking') {
      let partners = '';
      if (props?.participant.participantType === 'CUSTOMER') {
        partners = aggregators?.aggregatorInfo.concat(providers?.providerInfo);
        setPartners(partners);
      } else if (props?.participant.participantType === 'PROVIDER') {
        setPartners(customers?.serviceInfo);
      }
    }
    const workflow = workflowList.data?.workflow?.content?.filter(
      (content: any) => content?.workflowCode === workflowCode
    );
    const operationsList = workflow?.[0].operations;
    const operations = operationsList?.filter((operation: any) => operation?.initiator === initiator);
    setOperations(operations);
  }, [aggregators, providers, customers, workflowList]);

  const handleFormFields = ({ target: { name, value } }: any) => {
    if (value !== '') {
      setFormField(prevState => ({ ...prevState, [name]: value }));
    }
    if (name === 'simulationCode') {
      const operation = operations?.filter((item: any) => item.operationCode === value);
      setFormField(prevState => ({ ...prevState, simulationName: operation?.[0]?.operationName }));
    }
  };

  const resetForm = () => {
    setFormField({ ...initialState });
  };

  return (
    <>
      <Grid container alignItems="center" className={classes.form}>
        <Grid item xs={2}>
          <Typography className={classes.typographyLabel} variant="h3">
            Select Simulation Type
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Select
            id="Select-simulation"
            data-id="Select-simulation"
            name="simulationCode"
            onChange={handleFormFields}
            value={simulationCode}
            className={classes.select}
          >
            {operations?.map((operation: any) => (
              <MenuItem value={operation.operationCode}>{operation.operationName}</MenuItem>
            ))}
          </Select>
        </Grid>
        {workflowCode === 'freightTracking' && (
          <>
            <Grid item xs={2}>
              <Typography className={classes.typographyLabel} variant="h3">
                Select Partner
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Select
                id="Select-simulation"
                data-id="Select-simulation"
                name="partner"
                onChange={handleFormFields}
                value={partner}
                className={classes.select}
              >
                {partners?.length > 0 &&
                  partners.map((item: any) => <MenuItem value={item?.participantCode}>{item?.companyName}</MenuItem>)}
              </Select>
            </Grid>
          </>
        )}
        {testNames && testNames?.simulatedData?.length > 0 && (
          <>
            <Grid item xs={2}>
              <Typography className={classes.typographyLabel} variant="h3">
                Select Test Case
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Select
                id="Select-event"
                data-id="Select-event"
                name="eventType"
                onChange={handleFormFields}
                value={eventType}
                className={classes.select}
              >
                {testNames?.simulatedData
                  ?.filter((test: any) => test.operation === simulationName)
                  .map((item: any) => (
                    <MenuItem value={item.testDataName}>{item.testDataName}</MenuItem>
                  ))}
              </Select>
            </Grid>
          </>
        )}
        <>
          <Grid item xs={2}>
            <Typography className={classes.typographyLabel} variant="h3">
              Select {participant?.participantType === 'CUSTOMER' ? 'Provider' : 'Customer'}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Select
              id="Select-provider"
              data-id="Select-provider"
              name="providerCode"
              onChange={handleFormFields}
              value={providerCode}
              className={classes.select}
            >
              {participant?.participantType === 'CUSTOMER'
                ? providers?.providerInfo.map((provider: any) => (
                    <MenuItem value={provider.participantCode}>{provider.companyName}</MenuItem>
                  ))
                : providers?.providerInfo.map((provider: any) => (
                    <MenuItem value={provider.participantCode}>{provider.companyName}</MenuItem>
                  ))}
            </Select>
          </Grid>
        </>
      </Grid>
      <Grid container alignItems="center" className={classes.content}>
        <CertificationForm
          participant={participant}
          workflowCode={workflowCode}
          testNames={testNames?.simulatedData}
          intiator={initiator}
          customerCode={customerCode}
          providerCode={providerCode}
          simulationType={simulationCode}
          simulationName={simulationName}
          eventType={eventType}
          partner={partner}
          resetForm={resetForm}
        />
      </Grid>
    </>
  );
};
export default ServiceCertification;
